module.exports = __webpack_public_path__ + "img/me.ebe9d55a.svg";